import { useState, useCallback, useEffect } from 'react';
import { Button, Icon, Input } from 'lynkco-up-core';
import DealershipAdminsTable from './dealershipAdminTable';

import { addDealershipAdmin, getDealershipAdmins } from '../../services/dealerships';
import { DealershipUserV1, DealershipAdminReqV1 } from '../../services/dealerships/types';

const addDealershipAdminInputs = [
  { id: 'search_userId', name: 'userId', placeholder: 'User ID...', icon: 'person' },
  { id: 'search_email', name: 'email', placeholder: 'Email...', icon: 'email' },
] as const;

function DealershipAdmin() {
  const [addAdminQuery, setAddAdminQuery] = useState<DealershipAdminReqV1>({});
  const handleSearchChange = (event: React.FormEvent<HTMLInputElement>) => {
    const { name, value } = event.currentTarget;
    setAddAdminQuery(prev => ({ ...prev, [name]: value }));
  };
  const [dealershipAdmins, setDealershipAdmins] = useState<DealershipUserV1[]>();

  useEffect(() => {
    fetchDealershipAdmins();
  }, []);

  const fetchDealershipAdmins = useCallback(async () => {
    //This should be called after any add/remove
    try {
      const admins = await getDealershipAdmins2();
      setDealershipAdmins(admins);
    } catch (error) {
      console.error('Failed to fetch dealerships:', error);
    }
  }, []);

  const handleAddAdmin = async () => {
    if (!addAdminQuery.userId || !addAdminQuery.email) {
      alert('Please fill all required fields to add a vin.');
      return;
    }
    try {
      await addDealershipAdmin(addAdminQuery);
      fetchDealershipAdmins(); // Refresh data
    } catch (error) {
      console.error('Failed to add user:', error);
    }
  };
  async function getDealershipAdmins2(): Promise<DealershipUserV1[]> {
    const dealershipAdminPromise = await getDealershipAdmins();
    if (dealershipAdminPromise.dealershipadmins != undefined) {
      if (dealershipAdminPromise.dealershipadmins?.length > 1) {
        const promise = Promise.resolve(dealershipAdminPromise.dealershipadmins);
        return promise;
      }
    }
    const promise = Promise.resolve(dealershipAdminPromise.dealershipadmins ?? []);
    return promise;
  }
  return (
    <div className="p-7">
      <div className="basis-full md:basis-1/2 lg:basis-1/3 pr-6 mb-6">
        <h3 className="font-medium text-base">Make user dealership admin</h3>
        <div className="mt-4 w-96">
          {addDealershipAdminInputs.map(({ id, name, placeholder, icon }) => (
            <Input
              key={id}
              id={id}
              name={name} // Use name to identify the field
              placeholder={placeholder}
              leadingIcon={icon}
              value={addAdminQuery[name] || ''}
              onChange={handleSearchChange} // Use the dedicated handler
              extraClasses="mb-3"
            />
          ))}
        </div>
        <Button onClick={handleAddAdmin}>
          Add Dealership Admin
          <span className="ml-2 flex items-center">
            <Icon name="search" size="small" variant="light" padding={0} />
          </span>
        </Button>
        <DealershipAdminsTable
          data={dealershipAdmins ?? []}
          paginationStartIndex={0}
          paginationEndIndex={0}
          paginationQuantity={length}
          onPaginationNextChange={function (): void {
            throw new Error('Function not implemented.');
          }}
          onPaginationPreviousChange={function (): void {
            throw new Error('Function not implemented.');
          }}
          onRequestUpdate={getDealershipAdmins2}></DealershipAdminsTable>
      </div>
    </div>
  );
}

export default DealershipAdmin;
